<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" sm="6">
        <px-view-header-title title="Dashboard de vendas"/>
      </v-col>
      <v-col cols="12" sm="6" class="d-flex align-center justify-end">
        <px-px-select-date-range  :initial-date-selection="dateSelection"
                                  @change="onChangeDate"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { SET_DATE_ACT } from '@/store/dashboard-vendas/actions.type';
import PxSelectDateRange from './PxSelectDateRange.vue';

export default {
  computed: {
    ...mapGetters('dashboardVendas', ['dateSelection']),
  },
  methods: {
    ...mapActions('dashboardVendas', {
      setDateSelection: SET_DATE_ACT,
    }),
    onChangeDate(dateState) {
      this.setDateSelection(dateState);
      this.$emit('change', dateState);
    },
  },
  components: {
    pxPxSelectDateRange: PxSelectDateRange,
  },
};
</script>
